import { User } from './user'

class Formatter {
  static parseExternalUser(rawUser, token, refreshToken) {
    if (!rawUser) return null
    const user = new User()
    const profilePicture =
      rawUser.metadata.profilePictureUrl ||
      `https://ui-avatars.com/api/?background=111429&color=fff&name=${
        rawUser.firstName
      } ${rawUser.lastName}&bold=true&font-size=0.55`

    user
      .setFirstName(rawUser.firstName)
      .setLastName(rawUser.lastName)
      .setIsActive(!!rawUser.metadata?.isActive)
      .setPhoneNumber(rawUser.phoneNumber)
      .setEmail(rawUser.email)
      .setReference(rawUser.id)
      .setProfilePictureUrl(profilePicture)
      .setMetaData(formatMetaData(rawUser, token, refreshToken))

    return user
  }

  static buildUserEntity(rawUser) {
    if (!rawUser) return null
    const user = new User()
    user
      .setFirstName(rawUser.firstName)
      .setLastName(rawUser.lastName)
      .setIsActive(rawUser.isActive)
      .setPhoneNumber(rawUser.phoneNumber)
      .setEmail(rawUser.email)
      .setReference(rawUser.reference)
      .setProfilePictureUrl(rawUser.profilePictureUrl)
      .setMetaData(rawUser.metaData)

    if (!rawUser.metaData?.publicId) {
      user.setMetaData({
        ...rawUser.metaData,
        publicId: parseInt(rawUser.reference, 36),
      })
    }
    return user
  }
}

function formatMetaData(rawUser = {}, token = '', refreshToken = '') {
  const metaData = {
    userUuid: rawUser.id,
    firstName: rawUser.firstName,
    lastName: rawUser.lastName,
    phoneNumber: rawUser.phoneNumber,
    countryCode: rawUser.countryCode,
    email: rawUser.email,
    token,
    refreshToken,
    rawUser,
    metadata: rawUser.metadata,
  }
  return metaData
}

export { Formatter }
